import { usePaymentContext } from '../../../../context/PaymentContext';

import AutoRecurringInfo from './components/AutoRecurringInfo';
import InstallmentsInfo from './components/InstallmentsInfo';

const RecurringInfo = ({ totalAmount: totalAmountOverride, subject } = {}) => {
  const { values } = usePaymentContext();
  const recurringPayment = values?.recurringPayment;

  if (!recurringPayment) return null;

  const fallbackAmount = Number(recurringPayment?.amount);
  const baseAmount =
    totalAmountOverride ??
    (values?.amount
      ? Number(values.amount)
      : Number.isFinite(fallbackAmount)
        ? fallbackAmount
        : null);

  return recurringPayment.type === 'installments' ? (
    <InstallmentsInfo
      recurringPayment={recurringPayment}
      totalAmount={baseAmount}
      subject={subject}
    />
  ) : (
    <AutoRecurringInfo recurringPayment={recurringPayment} totalAmount={baseAmount} />
  );
};

export default RecurringInfo;
